import { onError } from '@apollo/client/link/error'

import { addBreadcrumb, captureException } from '@shared/lib/sentry'

export const sentryErrorLink = onError(({ graphQLErrors, networkError, operation }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path, extensions }) => {
      const errorInfo = {
        message,
        locations,
        path,
        extensions,
        operationName: operation.operationName,
        variables: operation.variables,
      }

      addBreadcrumb(
        `GraphQL error: ${message}`,
        'graphql',
        'error'
      )

      captureException(new Error(`GraphQL error: ${message}`), {
        contexts: {
          graphql: errorInfo,
        },
        tags: {
          errorType: 'graphql',
          operationName: operation.operationName || 'unknown',
        },
      })
    })
  }

  if (networkError) {
    addBreadcrumb(
      `Network error: ${networkError.message}`,
      'network',
      'error'
    )

    captureException(networkError, {
      contexts: {
        operation: {
          operationName: operation.operationName,
          variables: operation.variables,
        },
      },
      tags: {
        errorType: 'network',
        operationName: operation.operationName || 'unknown',
      },
    })
  }
})
